import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Stack, Typography } from '@mui/material';
import { GoogleCaptcha, type GoogleCaptchaRef } from '@/components/biz/google-captcha';
import { StepBox } from '@/components/layout/step-box';
import { Flow } from '@/constants/flow';
import { useBizState } from '@/hooks/use-biz-state';
import { useVerifyUsername } from '@/hooks/use-verify-username';

export const StepDisableRecovery: React.FC = () => {
  const { t } = useTranslation();
  const { userName, areaCode, authType } = useBizState();
  const recaptchaRef = useRef<GoogleCaptchaRef>(null);
  const [recaptchaToken, setRecaptchaToken] = useState('');
  const [recaptchaLoading, setRecaptchaLoading] = useState(false);
  const { doVerifyUserName, loading: requesting } = useVerifyUsername(
    'recovery',
    recaptchaRef,
    recaptchaToken,
    recaptchaLoading,
  );

  const handleCheckRecaptcha = () => {
    const isValid = recaptchaRef.current?.validation();
    return isValid;
  };

  const handleRecaptchaLoading = (loading: boolean) => {
    setRecaptchaLoading(loading);
  };

  const handleRecaptchaToken = (token: string) => {
    setRecaptchaToken(token);
  };

  const handleRecovery = () => {
    if (handleCheckRecaptcha()) {
      doVerifyUserName('recovery');
    }
  };

  return (
    <StepBox
      backFlow={Flow.LOGIN_STEP_INPUT_USERNAME}
      backButtonProps={{
        disabled: requesting,
      }}
      account={authType === 'phone' ? `${areaCode} ${userName}` : userName}
      title={t('account_locked_title')}
    >
      <Stack spacing={2}>
        <Typography variant="body1">{t('account_recovery_description')}</Typography>
        <GoogleCaptcha
          onLoadingChange={handleRecaptchaLoading}
          onTokenChange={handleRecaptchaToken}
          ref={recaptchaRef}
        />
        <Button variant="contained" onClick={handleRecovery} loading={recaptchaLoading || requesting} fullWidth>
          {t('account_recovery_button')}
        </Button>
      </Stack>
    </StepBox>
  );
};
